import type { Extension } from 'view/common/forge-ui/types';
export const getForgeUIType = (extension: Extension, entryPoint = ''): string => {
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const { render, resource } = entryPoint ? extension.properties[entryPoint] : extension.properties;
    if (resource) {
        if (render === 'native') {
            return 'ui-kit-2';
        }
        return 'custom-ui';
    }
    return 'ui-kit';
};
export const isCustomUIExtension = (extension: Extension) => {
    return getForgeUIType(extension) === 'custom-ui';
};
export const isUIKit2Extension = (extension: Extension) => {
    return getForgeUIType(extension) === 'ui-kit-2';
};
